/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Author M. Atoar Rahman
 * Title: Partner Stock Receive Context
 * Description: Page for Partner Stock Receive Context
 * Date: 22/06/2022
 */

import { createContext, useContext, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import UrlService from '../../../services/UrlService';

// Create Context
const ContextAPI = createContext();

export function usePartnerStockReceive() {
    return useContext(ContextAPI);
}

// Provider Component
export function PartnerStockReceiveProvider({ children }) {
    const [show, setShow] = useState(false);
    const [formShow, setFormShow] = useState(false);
    const [showPdf, setShowPdf] = useState(false);
    const [rowData, setRowData] = useState('');
    const [pendingData, setPendingData] = useState();
    const [approvedData, setApprovedData] = useState();
    const [pdfData, setPdfData] = useState();
    const [receiveList, setReceiveList] = useState({});
    const [receiveData, setReceiveData] = useState({});

    // Dependency
    const axiosPrivate = useAxiosPrivate();

    // API Function: Fatch All Data  All D2 Data
    const getPendingData = async () => {
        try {
            const response = await axiosPrivate.get(UrlService.getAllD2Url('supply_approved', 0), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setPendingData(response?.data?.d2_preparation_info);
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    const getApprovedData = async () => {
        try {
            const response = await axiosPrivate.get(UrlService.getAllD2Url('received', 0), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setApprovedData(response?.data?.d2_preparation_info);
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    return (
        <ContextAPI.Provider
            value={{
                show,
                setShow,
                showPdf,
                setShowPdf,
                rowData,
                setRowData,
                formShow,
                setFormShow,
                pendingData,
                getPendingData,
                approvedData,
                getApprovedData,
                pdfData,
                setPdfData,
                receiveList,
                setReceiveList,
                receiveData,
                setReceiveData,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
